export default __webpack_public_path__ + "static/media/world_map.bcd0f59a.png";